import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PermissionCreationComponent } from './permission-creation.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from '../../pipes/pipes.module';
import { IonicPaginationModule } from '../../components/ionic-pagination/ionic-pagination.module';
import { FiltersModalModule } from '../filters/filters.module';
import { OkrService } from 'src/app/okr/okr.service';
import { AttributeCreationComponent } from '../attribute-creation/attribute-creation.component';

@NgModule({
    declarations: [PermissionCreationComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        PipesModule,
        IonicPaginationModule,
        FiltersModalModule
    ],
    providers: [OkrService]
})
export class PermissionCreationModule { }
